import CustomerNotesPopup from "emun.customer/customer-notes-popup";
import labels from "emun.order/_labels";
import emailOrderPrompt from "emun.order/email-order-prompt";
import OrderChangesPrompt from "emun.order/modify-order/order-changes-prompt";
import OrderDetailsPrompt from "emun.order/order-details-prompt";
import OrderNotesPopup from "emun.order/order-notes-popup";
import PrintOrderOptions from "emun.order/order-print";
import OrderTotalsPrompt from "emun.order/order-totals-prompt";
import orderConfig from "emun.order/order.config";
import VendorShipmentPrompt from "emun.order/vendor-shipment-prompt";
import OrderLogDetail from "emun.order/order-log-detail";
import TagsPrompt from "servicestack/tags/tags-prompt";
import PrintItems from "emun.products/lists/product-list-print";
import config from "emun.retailer/retailer.config";
import resolve from "ioc/resolve";
import basicController from "servicestack/basic.controller.properties";
import ServiceBus from "servicestack/service-bus";
import modals from "webmodals/modals";

const $localStorage = resolve("$localStorage");

export default class OrderDetailsController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
  }

  $onInit() {
    const $ctrl = this;
    //console.debug("OrderDetailsController: ", this);
    if ($ctrl.$cart) $ctrl.order = $ctrl.$cart;
    $ctrl.mode = $ctrl.order.mode || "Order";
    if ($ctrl.openedit == "true" || $ctrl.openedit == true) $ctrl.edit();
    $ctrl.bus = new ServiceBus();
    $ctrl.hideParcels = config.hideParcels === true;
    $ctrl.hideTracking = config.hideTracking === true;
    $ctrl.orderConfig = orderConfig;
    $ctrl.$localStorage = $localStorage;
    $ctrl.itemsPerPage = "4";
    $ctrl.hidePrice = false;
    $ctrl.orderNotesExists = false;
    $ctrl.labels = labels;
    // $ctrl.isCollapsedInfo =
    //   $ctrl.$pageConfig.width < 544 || $ctrl.orderConfig.collapseOrderHeader;
    $ctrl.isCollapsedInfo = $ctrl.orderConfig.collapseOrderHeader;

    $ctrl.navs = $ctrl.$state.getNav($ctrl.mode.toLowerCase() + "s.detail");
    // console.debug(
    //   "ctrl.$state.get(): ",
    //   $ctrl.$state.get().reduce((r, s) => Object.assign(r, { [s.name]: s }), {})
    // );
    // console.debug("ctrl.navs: ", $ctrl.navs);
    if ($ctrl.$session.isAgency()) {
      $ctrl.bus
      .read("QueryVendorInvoices.json", {
        fields: "Id",
        orderNumber: this.orderId,
      })
      .then((r) => {
        if (r.data.total === 0) {
          $ctrl.navs = $ctrl.navs.filter(
            (s) => s.name.indexOf("vendorinvoices") === -1
          );
        }
      });
    } else {
      $ctrl.bus
      .read("QueryInvoices.json", {
        fields: "Id",
        orderNumber: this.orderId,
      })
      .then((r) => {
        if (r.data.total === 0) {
          $ctrl.navs = $ctrl.navs.filter(
            (s) => s.name.indexOf("invoice") === -1
          );
        }
      });
    }
    $ctrl.bus
      .read("QueryChangeNotices.json", {
        fields: "ProductId",
        orderNumber: this.orderId,
      })
      .then((r) => {
        //console.info("r.data.total", r.data.total);
        if (r.data.total === 0) {
          $ctrl.navs = $ctrl.navs.filter(
            (s) => s.name.indexOf("change-notice") === -1
          );
        }
      });

    $ctrl.bus
      .read("QueryOrderNotes.json", {
        fields: "Id",
        orderNumber: this.orderId,
      })
      .then((r) => {
        if (r.data.total > 0) {
          $ctrl.orderNotesExists = true;
        }
      });
    $ctrl.bus.read("QueryTags.json", {
      Shard: "Order",
      PrincipalId: this.orderId
    })
    .then((r) => {
      $ctrl.tags = {};
      r.data.results.map(r => {
        $ctrl.tags[r.tagKind] = [r.tagLabel];
      });
    });

    $ctrl.$on("$vendorShipmentApplied", () => $ctrl.$cart.load($ctrl.order.id));
    $ctrl.$cart.$$load.then(() => {
      if (orderConfig.showRefreshCart && $ctrl.$cart.status == "Cart") {
        if (moment.utc($ctrl.$cart.orderedOn).isBefore(moment.utc().startOf('day'))) {
          $ctrl.$cart.refreshCart(this.orderId);
        }
      }
    });
  }

  isEditable() {
    const $ctrl = this;
    return $ctrl.order.canEdit || $ctrl.order.agencyCanEdit;
  }
  edit() {
    const $ctrl = this;
    return (
      $ctrl.isEditable() &&
      OrderDetailsPrompt.open({
        order: $ctrl.order,
        mode: $ctrl.mode,
      }).then(() => $ctrl.$cart.load($ctrl.order.id))
    );
  }
  totals() {
    const $ctrl = this;
    return OrderTotalsPrompt({ order: $ctrl.order });
  }

  vendorShipment() {
    const $ctrl = this;
    return VendorShipmentPrompt({ order: $ctrl.order });
  }
  viewLogs(order) {
    let $ctrl = this;
    return OrderLogDetail({ order: order });
  }
  export() {
    const $ctrl = this;
    let url = $ctrl.$appConfig.resolveServiceUrl(
      "SalesOrderLinesExport?OrderNumber=" + $ctrl.order.id
    );
    return (location.href = url);
  }
  exportQuickReport(reportName) {
    const $ctrl = this;
    let url = $ctrl.$appConfig.resolveServiceUrl(
      "RunReport?reportName=QuickReport&displayName=" +
        reportName +
        " &output=xlsx&QuickReportID=" +
        reportName +
        "&QuickReportName=" +
        reportName +
        "&@strOrderNumber=" +
        $ctrl.order.id +
        "&expandKits=True"
    );

    return (location.href = url);
  }
  exportQuickReportImages(reportName) {
    const $ctrl = this;
    let url = $ctrl.$appConfig.resolveServiceUrl(
      "RunReport?reportName=QuickReport&displayName=" +
        reportName +
        " &output=xlsx&QuickReportID=" +
        reportName +
        "&QuickReportName=" +
        reportName +
        "&@strOrderNumber=" +
        $ctrl.order.id +
        "&expandKits=True&displayImage=True"
    );
    //console.info("url", url);
    return (location.href = url);
  }
  exportWithImages() {
    const $ctrl = this;
    let url = $ctrl.$appConfig.resolveServiceUrl(
      "RunReport?reportName=OrderExport&displayName=OrderExport&output=xlsx&orderNumber=" +
        $ctrl.order.id
    );
    return (location.href = url);
  }
  exportMultipleUPC() {
    const $ctrl = this;
    let url = $ctrl.$appConfig.resolveServiceUrl(
      "RunReport?reportName=UMAMultipleUPC&displayName=MultipleUPC&output=xlsx&orderNumber=" +
        $ctrl.order.id
    );
    return (location.href = url);
  }
  orderNotes() {
    const $ctrl = this;
    return OrderNotesPopup({
      order: {
        id: $ctrl.order.id,
        canEdit: $ctrl.isEditable(),
      },
    });
  }
  customerNotes() {
    const $ctrl = this;
    return CustomerNotesPopup({
      customer: {
        id: $ctrl.order.retailerId,
        customerId: $ctrl.order.retailerId,
      },
    });
  }
  exitOrder(OrderID) {
    let $ctrl = this;
    let orderId = OrderID != undefined ? OrderID : $ctrl.order.id;
    $ctrl.$cart.exitOrder(orderId, true);
  }

  checkout() {
    let $ctrl = this;
    if (!$ctrl.order.canEdit) return false;
    $ctrl.$cart.removeOrderFromSession($ctrl.order.id);
    $ctrl.order.checkOffers($ctrl.$cart.id, "Checkout");
  }
  //printOrder(order) {
  //    let $ctrl = this;
  //    var url = $ctrl.$appConfig.serviceUrl + "PrintOrder/" + order;
  //    return window.open(url);
  //}

  emailOrder() {
    const $ctrl = this;
    return emailOrderPrompt({
      model: {
        orderNumber: $ctrl.order.id,
        from: $ctrl.$session.email,
        to: $ctrl.order.purchaser.email,
        subject: $ctrl.$session.clientName + " Order #" + $ctrl.order.id,
        clientName: $ctrl.$session.clientName,
        status: $ctrl.order.status,
      },
    });
  }

  printOrder() {
    const $ctrl = this;
    return PrintOrderOptions({
      request: {
        id: $ctrl.order.id,
        IncludeImages: false,
        IncludeBarcodes: false,
        OrderBy: "strProductID",
      },
    });
  }

  printItems() {
    const $ctrl = this;
    return PrintItems({
      request: {
        onOrder: $ctrl.order.id,
        pricelist: $ctrl.order.priceList,
        itemsPerPage: $ctrl.itemsPerPage,
        hidePrice: $ctrl.hidePrice,
        name: "Order: " + $ctrl.order.id,
      },
    });
  }

  delete() {
    const $ctrl = this;
    return modals
      .confirm("Are you sure?", "Delete Order")
      .result.then(function () {
        $ctrl.bus
          .send("DeleteOrder.json", { Id: $ctrl.order.id, CartId: $ctrl.order.id})
          .then(function (response) {
            // const [nextOrderId] = $ctrl.$cart
            //   .ordersInSession()
            //   .filter((o) => o.id !== $ctrl.order.id);
            // console.debug("nextOrderId", nextOrderId, {
            //   ...$ctrl.$state.fromParams,
            //   ...$ctrl.$state,
            //   nextOrderId,
            //   $ctrl,
            // });
            $ctrl.$cart.removeOrderFromSession($ctrl.order.id);
            if ($ctrl.$cart.orderCountInSession() > 0) {
              $ctrl.$state.transitionTo(
                $ctrl.$state.fromState &&
                  $ctrl.$state.fromState.name.indexOf("cust.details.order") ===
                    0
                  ? "cust.details.order.detail"
                  : "orders.detail",
                {
                  ...$ctrl.$state.fromParams,
                  orderId: $ctrl.$cart.ordersInSession()[0].id, //nextOrderId,
                }
              );
            } else {
              $ctrl.$cart.reset();
              $ctrl.$state.transitionTo(
                $ctrl.$state.fromState &&
                  $ctrl.$state.fromState.name.indexOf("cust.details.order") ===
                    0
                  ? "cust.details.order"
                  : "orders",
                $ctrl.$state.fromParams
              );
            }
            $ctrl.$emit("orderDeleted", $ctrl);

            //$ctrl.$cart.load($ctrl.order.id);
            //$ctrl.$state.transitionTo('orders')
          });
      });
  }

  reExport() {
    const $ctrl = this;
    return modals
      .confirm("Are you sure?", "Re-Export Order")
      .result.then(function () {
        $ctrl.bus
          .send("ReExportOrder.json", $ctrl.order)
          .then(function (response) {
            $ctrl.$emit("orderReExported", $ctrl);
            $ctrl.$cart.load($ctrl.order.id);
          });
      });
  }

  resendApprovalRequest() {
    const $ctrl = this;
    return modals
      .confirm("Are you sure?", "Resend Approval Request")
      .result.then(() =>
        $ctrl.bus
          .send("ResendApprovalRequest.json", { cartId: $ctrl.order.id })
          .then(() =>
            resolve("notify").success($ctrl.order.id, {
              title: "Approval Request Set",
              ttl: 5000,
              disableCountDown: true,
            })
          )
      );
  }

  resendPaymentRequest() {
    const $ctrl = this;
    return modals
      .confirm("Are you sure?", "Resend Payment Request")
      .result.then(() =>
        $ctrl.bus.send("ResendPaymentRequest.json", $ctrl.order).then(() =>
          resolve("notify").success($ctrl.order.id, {
            title: "Payment Request Set",
            ttl: 5000,
            disableCountDown: true,
          })
        )
      );
  }

  createOrder() {
    let $ctrl = this;
    $ctrl.$cart.createPrompt({
      mode: $ctrl.mode,
      status: $ctrl.mode === "Quote" ? "Quote" : "Cart",
      retailer: $ctrl.order.purchaser,
      paymentTermsId: $ctrl.order.paymentTermsId,
      shippingLocation: $ctrl.order.shippingLocation,
      buyer: $ctrl.order.buyer,
    });
  }

  //https://emun1.monday.com/boards/333027351/views/4635648/pulses/833175192?advancedFilters=true&people=person-10628996
  getOrderIndex(id) {
    const $ctrl = this;
    return $ctrl.container.query.results.findIndex(
      (r) => r.id === (id || $ctrl.order.id)
    );
  }

  canGoNext() {
    const $ctrl = this;
    $ctrl.orderIndex = $ctrl.getOrderIndex($ctrl.order.id);
    return $ctrl.orderIndex < $ctrl.container.query.results.length - 1;
  }
  nextOrder() {
    const $ctrl = this;
    if ($ctrl.canGoNext()) {
      return $ctrl.selectOrder(
        $ctrl.container.query.results[$ctrl.orderIndex + 1]
      );
    }
  }
  getNextOrder() {
    const $ctrl = this;
    if ($ctrl.canGoNext()) {
      return $ctrl.container.query.results[$ctrl.orderIndex + 1];
    }
  }
  canGoPrev() {
    const $ctrl = this;
    $ctrl.orderIndex = $ctrl.getOrderIndex($ctrl.order.id);
    return $ctrl.orderIndex > 0;
  }
  prevOrder() {
    const $ctrl = this;
    if ($ctrl.canGoPrev()) {
      return $ctrl.selectOrder(
        $ctrl.container.query.results[$ctrl.orderIndex - 1]
      );
    }
  }
  getPrevOrder() {
    const $ctrl = this;
    if ($ctrl.canGoNext()) {
      return $ctrl.container.query.results[$ctrl.orderIndex + 1];
    }
  }
  selectOrder(order) {
    const $ctrl = this;
    $ctrl.$state.go(".", { orderId: order.id });
    // $ctrl.$cart.load(order.id).then((c) => $ctrl.$onInit());
    // $ctrl.orderIndex = $ctrl.getOrderIndex(order.id);
  }
  clearReview(order) {
    const $ctrl = this;
    return modals.confirm("Clear review status for this order?", "Clear Review Status").result.then(function() {
      $ctrl.$cart.bus.send("ClearReview.json", {
        OrderNumber: order.id
      }).then(function(response) {
        $ctrl.$cart.load(order.id)
      });
    });
    
  }
  modify() {
    const $ctrl = this;
    return $ctrl.$cart
      .openModifyOrder()
      .then(() => $ctrl.$cart.load($ctrl.order.id));
  }
  showChanges(id) {
    let $ctrl = this;
    return OrderChangesPrompt({ id: id });
  }
  editTags(order) {
    const $ctrl = this;
    return TagsPrompt.open({
      title: order.id + " - " + " Tags...",
      tags: $ctrl.tags,
      principalId: order.id,
      shard: "Order",
    }).then(() => $ctrl.query.load(true));
  }

}
